// extracted by mini-css-extract-plugin
export default {"pageContainer":"NotFoundPage_pageContainer__T6pAH","text":"NotFoundPage_text__ucxgo","link":"NotFoundPage_link__iZyh1"};